<template>
  <div class="tags mt-3" v-if="tags">
    <span class="tag" v-for="tag in tags" :key="'tag_' + tag.term_id">
      #{{ tag.name | convertEsperluette }}
    </span>
  </div>
</template>

<script>
export default {
  name: "Tags",
  props: {
    tagsArray: Array,
  },
  computed: {
    tags: function () {
      let tags = [];
      let tags_ids = [];

      const that = this;

      this.tagsArray.forEach(function (item) {
        const newTag = that.$store.getters.getTagById(item);
        if (!tags_ids.includes(newTag["name"])) {
          tags_ids.push(newTag["name"]);
          tags.push(newTag);
        }
      });

      return tags;
    },
  },
  filters: {
    convertEsperluette: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.replace(/&amp;/gi, "&");
    },
  },
};
</script>
